import createReactClass from "create-react-class";
import _ from "lodash";
import ColorPicker from "rc-color-picker";
import React from "react";
import injectSheet from "react-jss";
import COLOURS from "util/colours";

const simpleColorTransitions = {
  colorPicker: {
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
  },
  colorPickerLabel: {
    fontSize: "11px",
    fontFamily: "Larsseit-Medium",
    lineHeight: "11px",
    color: COLOURS.ink,
  },
  picker: {
    display: "flex",
    marginTop: "8px",
    "& span": {
      border: `2px solid ${COLOURS.cloudGrey}`,
      borderRadius: "50%",
    },
  },
};

let SimpleColorPicker = createReactClass({
  displayName: "SimpleColorPicker",

  getInitialState: function () {
    if (this.props.value) return this.props.value;

    var obj = _.merge(
      {},
      {
        color: {
          color: "#00000",
          alpha: 100,
        },
      },
      this.props.model[this.props.attr],
    );
    return obj;
  },

  componentDidUpdate(prevProps) {
    if (!this.props.model) return;

    // Check styles.fontColor change
    const prevFontColor = _.get(prevProps, `styles.${this.props.attr}.fontColor`);
    const nextFontColor = _.get(this.props, `styles.${this.props.attr}.fontColor`);

    if (nextFontColor && nextFontColor !== prevFontColor) {
      this.setState({ currentColor: nextFontColor });
    }

    // Check model.color change
    const prevModelColor = _.get(prevProps, `model.${this.props.attr}.color`);
    const nextModelColor = _.get(this.props, `model.${this.props.attr}.color`);

    if (nextModelColor && !_.isEqual(prevModelColor, nextModelColor)) {
      this.setState({ color: nextModelColor });
    }
  },

  handleChangeComplete: _.debounce(
    function (color) {
      if (!this.props.model) return;
      var data = {
        fonts: {},
      };
      data.fonts[this.props.attr] = {
        color: color,
      };
      this.props.updateAttr("styles", data);
    },
    500,
    this,
  ),

  setCurrentColor: function (color) {
    const { onChange = () => {} } = this.props;
    this.handleChangeComplete(color);
    this.setState({ color: color }, () => onChange(color));
  },

  render: function () {
    const { label, colorPosition, classes: css, customStyleClass, disableAlpha } = this.props;
    const { color, alpha } = this.state.color;

    return (
      <div className={`${css.colorPicker} ${customStyleClass}`}>
        <div className={css.colorPickerLabel}>{label}</div>
        <ColorPicker
          animation="slide-up"
          onClose={this.handleChangeComplete}
          onChange={this.setCurrentColor}
          color={color}
          alpha={alpha}
          placement="topRight"
          className={css.picker}
          enableAlpha={!disableAlpha}
        />
      </div>
    );
  },
});

export default injectSheet(simpleColorTransitions)(SimpleColorPicker);
